import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

import { PreviewDevice, PreviewDevices } from '@empathy/survey/base';

@Directive({ selector: '[empathyPreviewDevice]' })
export class PreviewDeviceDirective implements OnChanges {
  @Input() activeDevice: PreviewDevice;
  @Input() landscape: boolean;

  constructor(private el: ElementRef) {}

  ngOnChanges(): void {
    this.stylePreviewDevice();
  }

  private stylePreviewDevice(): void {
    const device = PreviewDevices[this.activeDevice];

    const htmlElement: HTMLElement = this.el.nativeElement;

    const deviceWidth = this.landscape ? device.height : device.width;
    const deviceHeight = this.landscape ? device.width : device.height;

    const frameWidth = deviceWidth + 32;
    const frameHeight = deviceHeight + 32;

    htmlElement.style.height = `${frameHeight}px`;
    htmlElement.style.width = `${frameWidth}px`;
    (htmlElement.firstElementChild as HTMLElement).style.height = `${deviceHeight}px`;
    (htmlElement.firstElementChild as HTMLElement).style.width = `${deviceWidth}px`;
  }
}
